import MobilePageHeadMenu from './src';

export default MobilePageHeadMenu;
